var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticStyle:{"background":"white"},attrs:{"colspan":_vm.enableAI ? 6 : 5}},[_c('content-loader',{attrs:{"width":"600","height":"30","preserveAspectRatio":"none"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }